export const selectClickData = (state) => state.location.click.data;
export const selectClickLoading = (state) => state.location.click.loading;
export const selectClickError = (state) => state.location.click.error;
